export default __webpack_public_path__ + "static/media/invite-user-modal-img.e9ef0425.svg";